export class NotificationCommunity {
    public edhFinancialCommunityId: number; 
    public notificationCommunityId: number;
    public notificationId: number;
}